import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import StructuredData from '@/components/base/StructuredData';
import HeroSection from './components/HeroSection';
import FeaturedGrid from './components/FeaturedGrid';
import LatestUpdates from './components/LatestUpdates';
import CategoryEntry from './components/CategoryEntry';
import ReviewWall from './components/ReviewWall';
import FaqSection from './components/FaqSection';

export default function Home() {
  return (
    <>
      <StructuredData type="Organization" />
      <StructuredData type="WebSite" />
      <StructuredData type="WebPage" />
      <StructuredData type="BreadcrumbList" />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <article>
            <HeroSection />

            <FeaturedGrid />

            <section className="py-1 bg-background-50"></section>

            <LatestUpdates />

            <CategoryEntry />

            <ReviewWall />

            <FaqSection />
          </article>
        </main>

        <Footer />
      </div>
    </>
  );
}